export default "__VITE_PUBLIC_ASSET__f27c927e__"